//user reducerr types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const LOADING_USER = 'LOADING_USER';
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';
//UI Reducer types
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOADING_DATA= 'LOADING_DATA';
export const STOP_LOADING_UI= 'STOP_LOADING_UI'
//Data reducer types
export const SET_NOTES= 'SET_NOTES';
export const SET_NOTE= 'SET_NOTE';
export const SHIELD_NOTE= 'SHIELD_NOTE';
export const UNSHIELD_NOTE= 'UNSHIELD_NOTE';
export const DELETE_NOTE= 'DELETE_NOTE';
export const POST_NOTE= 'POST_NOTE';
export const SUBMIT_COMMENT = 'SUBMIT_COMMENT';


